"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as n } from "../../hooks.js";
import { useIsInverseVariant as m } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: v, size: c = 24 } = _param, o = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = m(), s = v !== null && v !== void 0 ? v : h ? r.colors.inverse : r.colors.neutralHigh, { skinName: t } = n();
    return t.match(/^o2-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: s,
            d: "M22 9.074v.664c0 .59-.215 1.14-.608 1.508a1.79 1.79 0 0 1-1.284.551h-.252v6.993c0 1.216-.964 2.21-2.143 2.21H6.287c-1.18 0-2.143-.994-2.143-2.21v-6.993h-.252a1.78 1.78 0 0 1-1.284-.55C2.215 10.878 2 10.326 2 9.737v-.664C2.037 5.54 6.287 3 12 3s9.963 2.54 10 6.074m-11.965 2.393c-.69 0-1.248.575-1.248 1.287 0 .711.558 1.286 1.248 1.286s1.247-.575 1.247-1.286-.557-1.287-1.247-1.287m1.252 4.972c0 .711-.558 1.286-1.248 1.286s-1.247-.575-1.247-1.286.557-1.287 1.247-1.287 1.248.575 1.248 1.287m1.43-3.685c0-.712.558-1.287 1.248-1.287s1.248.575 1.248 1.287c0 .711-.558 1.286-1.248 1.286s-1.247-.575-1.247-1.286m4.886-.919c-1.037 0-1.892-.919-1.892-2.06v-.734c0-.957-1.536-1.989-3.716-1.989S8.28 8.084 8.28 9.041v.735c0 1.14-.855 2.059-1.892 2.059h-.823v6.993c0 .405.32.735.713.735h11.426c.393 0 .713-.33.713-.735v-6.993zm2.967-2.723c-.037-2.649-3.748-4.637-8.57-4.637S3.467 6.459 3.43 9.112v1.253h3.392V8.928c.036-1.913 2.322-3.35 5.178-3.35 2.857 0 5.142 1.437 5.178 3.35v1.437h3.392zm-7.852 7.322c0-.712.557-1.286 1.247-1.286s1.248.58 1.248 1.29c0 .712-.558 1.287-1.248 1.287s-1.247-.58-1.247-1.291"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, o), {
        children: /* @__PURE__ */ e("path", {
            fill: s,
            d: "M22 9.074v.664c0 .59-.215 1.14-.608 1.508a1.79 1.79 0 0 1-1.284.551h-.252v6.993c0 1.216-.964 2.21-2.143 2.21H6.287c-1.18 0-2.143-.994-2.143-2.21v-6.993h-.252a1.78 1.78 0 0 1-1.284-.55C2.215 10.878 2 10.326 2 9.737v-.664C2.037 5.54 6.287 3 12 3s9.963 2.54 10 6.074m-11.965 2.393c-.69 0-1.248.575-1.248 1.287 0 .711.558 1.286 1.248 1.286s1.247-.575 1.247-1.286-.557-1.287-1.247-1.287m1.252 4.972c0 .711-.558 1.286-1.248 1.286s-1.247-.575-1.247-1.286.557-1.287 1.247-1.287 1.248.575 1.248 1.287m1.43-3.685c0-.712.558-1.287 1.248-1.287s1.248.575 1.248 1.287c0 .711-.558 1.286-1.248 1.286s-1.247-.575-1.247-1.286m4.886-.919c-1.037 0-1.892-.919-1.892-2.06v-.734c0-.957-1.536-1.989-3.716-1.989S8.28 8.084 8.28 9.041v.735c0 1.14-.855 2.059-1.892 2.059h-.823v6.993c0 .405.32.735.713.735h11.426c.393 0 .713-.33.713-.735v-6.993zm2.967-2.723c-.037-2.649-3.748-4.637-8.57-4.637S3.467 6.459 3.43 9.112v1.253h3.392V8.928c.036-1.913 2.322-3.35 5.178-3.35 2.857 0 5.142 1.437 5.178 3.35v1.437h3.392zm-7.852 7.322c0-.712.557-1.286 1.247-1.286s1.248.58 1.248 1.29c0 .712-.558 1.287-1.248 1.287s-1.247-.58-1.247-1.291"
        })
    }));
}, u = i;
export { u as default };
